import { getEnvOrDefault } from './runtime-env';

/**
 * Heap Analytics config.
 *
 * @property {string} appId='282132228' - App ID.
 */
const heapAnalyticsConfig = {
  appId: getEnvOrDefault('NEXT_PUBLIC_HEAP_ANALYTICS_APP_ID', '282132228'),
};

export default heapAnalyticsConfig;
